import { usePartnerContext } from "@tm/ui-widgets/hooks";
import { theme } from "@tm/utility/global";
import React from "react";
import { H3TagStyle } from "./TextStyles.style";

type Colors = typeof theme;
type ColorKey = keyof Colors;
interface H3TagProps {
  color?: Colors[ColorKey];
  children?: React.ReactNode;
  margin?: string;
}

const H3Tag: React.FC<H3TagProps> = ({ children, margin, color }) => {
  const context = usePartnerContext();
  return (
    <H3TagStyle
      context={context ? context : undefined}
      txtcolor={color}
      margin={margin}
    >
      {children}
    </H3TagStyle>
  );
};

export default H3Tag;
